import { ActionTree } from 'vuex';

import store from '@/store';
import { IGetBfixJobs, IGetJobs, Job, State } from '@/models/main';

export const actions: ActionTree<State, State> = {
  async addNote(vuex, params) {
    vuex.commit('ADD_NOTE', params);
  },
  async setJobData(vuex, val: IGetJobs) {
    vuex.commit('SET_JOB_DATA', val);
    await store.dispatch('orderJobs');
  },
  async clearJobData(vuex) {
    vuex.commit('CLEAR_JOB_DATA');
  },
  async setJobBfixData(vuex, val: IGetBfixJobs) {
    vuex.commit('SET_JOB_BFIX_DATA', val);
  },
  async orderJobs(vuex) {
    vuex.commit('ORDER_JOBS');
  },
  async setSearch(vuex, val: string) {
    vuex.commit('SET_SEARCH', val);
  },
  async setCategory(vuex, val: string) {
    vuex.commit('SET_CATEGORY', val);
  },
  async setBfixCategory(vuex, val: string) {
    vuex.commit('SET_BFIX_CATEGORY', val);
  },
  async setSelectedStates(vuex, val: string[]) {
    vuex.commit('SET_SELECTED_STATES', val);
  },
  async setDrivers(vuex, val: number[]) {
    vuex.commit('SET_DRIVERS_SELECT', val);
  },
  async setSideMenuOpen(vuex, val: boolean) {
    vuex.commit('SET_SIDE_MENU_OPEN', val);
  },
  async ERROR(vuex, error: number | undefined) {
    vuex.commit('SET_ERROR', error);
  },
  async updateJobData(vuex, val: Job) {
    if (val.status >= 5) {
      vuex.commit('SET_JOB_COMPLETE', val);
    } else {
      vuex.commit('UPDATE_JOB_IN_PROGRESS_STATUS', val);
    }
  },
  async toggleJobRequestForChange(vuex, val: Job) {
    vuex.commit('TOGGLE_JOB_REQUEST_FOR_CHANGE', val);
  },
};
